export const BUSINESS = {
  name: "Bahra Skincare",
  tagline: "Radiant, healthy skin, beautifully personalized.",
  phone: "(773) 600-1231",
  phoneHref: "tel:+17736001231",
  email: "facialetc17@gmail.com",
  emailHref: "mailto:facialetc17@gmail.com",
  address: "8307 W Golf Rd, Suite #144, Niles, IL 60714",
  addressShort: "Niles, Illinois",
  mapsQuery: "8307 W Golf Rd Suite 144 Niles IL 60714",
  bookingUrl:
    "https://book.squareup.com/appointments/794613a6-2d44-48cf-8041-6ec7f85c8f26/location/L7Y4CXXG6XEH0/services?rwg_token=AE37R_gZFLzNRWe36ukJ5p-06Ry3sXZxym8pkAjfRiB7LVSimXAQy-dQtjCco-fxSKsHXNWz-KT4NSkOxVSRoTXoHP99li2gcQ%3D%3D",
  googleReviewsUrl: "https://share.google/bfIgvbPJ6424hhOGV",
  award: {
    image: "/images/award-2026.webp",
    title: "Best of 2026 · Award Winner",
    subtitle: "BusinessRate · Powered by Google Reviews",
    alt: "Best of 2026 Award Winner badge from BusinessRate for Bahra Skincare, Facial Spa in Niles, Illinois, powered by Google Reviews",
  },
  social: {
    instagram: "https://www.instagram.com/bahraskincare/",
    facebook: "https://www.facebook.com/p/Bahra-Skincare-100070456452765/",
    tiktok: "https://www.tiktok.com/@bahraali3",
  },
  hours: [
    { day: "Monday", value: "Closed", closed: true },
    { day: "Tuesday", value: "10:00 AM – 3:00 PM" },
    { day: "Wednesday", value: "10:00 AM – 6:00 PM" },
    { day: "Thursday", value: "10:00 AM – 6:00 PM" },
    { day: "Friday", value: "10:00 AM – 6:00 PM" },
    { day: "Saturday", value: "10:00 AM – 6:00 PM" },
    { day: "Sunday", value: "10:00 AM – 4:00 PM" },
  ],
  amenities: [
    "By appointment only",
    "Accepts credit cards",
    "Private lot parking",
    "Free Wi-Fi",
    "Wheelchair accessible",
    "Women-owned business",
  ],
  policies: [
    {
      title: "Cancellation Policy",
      body: "Please reschedule or cancel your appointment at least two days prior to the scheduled time. Failure to provide sufficient notice may result in a cancellation fee.",
    },
    {
      title: "No-Show Policy",
      body: "Clients who fail to arrive for a scheduled appointment without prior notice may be charged a fee equal to 50% of the reserved service.",
    },
  ],
  about: {
    bio: "With over 10 years of experience as a licensed Skincare Specialist, I specialize in facials, advanced skin treatments, and comprehensive skincare. My passion is helping clients achieve healthy, radiant skin through personalized and professional care. Thank you for choosing me to be a part of your skincare journey.",
    description:
      "We are dedicated to delivering personalized skincare solutions that help our clients achieve the youthful, radiant glow they deserve. Our spa exclusively uses the highest-quality products to ensure optimal results. Experience rejuvenated skin through our organic and natural approach, carefully tailored to each client's unique needs. We offer a full suite of day spa services, including facials, advanced skin technology treatments, eyebrow shaping, and tinting.",
  },
  services: [
    {
      name: "Signature Facials",
      icon: "Sparkles",
      desc: "Deeply cleansing, hydrating facials tailored to your skin's unique needs for an immediate, luminous glow.",
    },
    {
      name: "Advanced Skin Treatments",
      icon: "Wand2",
      desc: "Results-driven treatments such as Derma Pen treatments and chemical exfoliation to renew tone, texture, and clarity.",
    },
    {
      name: "Skin Technology",
      icon: "Zap",
      desc: "HydraFacial, dermaplaning, LED light therapy, and microcurrent facials for smoother, brighter, firmer-looking skin.",
    },
    {
      name: "Eyebrow Shaping",
      icon: "Eye",
      desc: "Expert shaping that frames your face and enhances your natural features.",
    },
    {
      name: "Tinting",
      icon: "Palette",
      desc: "Brow and lash tinting for defined, effortless everyday beauty.",
    },
    {
      name: "Comprehensive Skincare",
      icon: "Leaf",
      desc: "Personalized skincare guidance and routines built around your goals and lifestyle.",
    },
  ],
  menu: {
    note:
      "All prices are starting rates. Final pricing may vary based on your skin's needs, and we'll always confirm before your treatment begins.",
    categories: [
      {
        title: "Signature Facials",
        subtitle: "Classic, restorative treatments tailored to every skin type and stage of life.",
        icon: "Sparkles",
        items: [
          {
            name: "Classic Facial",
            price: 125,
            desc: "A relaxation facial tailored to concerns such as congestion, dullness, sensitivity, fine lines, and loss of firmness. Enjoy deep pore cleansing, exfoliation, extractions, and total relaxation. An excellent treatment for all skin types.",
          },
          {
            name: "Anti-Aging Facial",
            price: 140,
            desc: "Designed to slow the visible signs of aging, brighten the skin, and soften fine lines and wrinkles. Features vitamin-infused serums, collagen creams, rejuvenating facial massage, and light therapy options for younger-looking skin.",
          },
          {
            name: "Rejuvenating Facial",
            price: 150,
            desc: "An anti-aging treatment designed to repair and restore fatigued, sun-damaged, or mature skin. Diminishes the appearance of fine lines and wrinkles, improves texture, and reveals an overall healthy, soft, youthful glow.",
          },
          {
            name: "Brightening Facial",
            price: 140,
            desc: "An illuminating treatment that targets dullness, uneven tone, and dark spots. Gentle exfoliation and brightening actives work together to reveal a fresh, radiant, luminous complexion.",
          },
          {
            name: "Deep Cleaning Facial / Acne Facial",
            price: 140,
            desc: "Rescue congested, lackluster skin while defending it from pore-clogging impurities. This detoxifying facial encourages the skin to purge, cleanse, and rebuild healthy texture. The ideal treatment for problematic, acne-prone skin.",
          },
          {
            name: "Sensitive Facial",
            price: 140,
            desc: "Designed to soothe fragile, reactive skin. This treatment gently exfoliates, cools, and calms while maintaining hydration and visibly reducing redness.",
          },
          {
            name: "Organic Facial",
            price: 140,
            desc: "A pure, plant-powered facial using the finest organic and natural products to nourish, balance, and restore your skin. Ideal for those seeking a clean, holistic approach to skincare.",
          },
          {
            name: "Bridal Facial",
            price: 150,
            desc: "A radiance-boosting treatment tailored to your special day. Deep hydration, gentle exfoliation, and glow-enhancing techniques leave your skin picture-perfect and camera-ready.",
          },
          {
            name: "Teen Facial",
            price: 120,
            desc: "A gentle facial designed for younger skin. Deep cleansing, light exfoliation, and balancing care help manage breakouts while building healthy skincare habits early.",
          },
          {
            name: "Back Facial",
            price: 120,
            desc: "A deep-cleansing treatment for hard-to-reach skin. Thorough cleansing, exfoliation, extractions, and hydration leave the back smooth, clear, and refreshed.",
          },
        ],
      },
      {
        title: "Advanced Treatments",
        subtitle: "Results-driven, professional-grade treatments for renewal, resurfacing, and radiance.",
        icon: "Wand2",
        items: [
          {
            name: "Derma Pen Treatment & Chemical Exfoliation",
            price: 280,
            desc: "Our most advanced renewal pairing. Derma Pen treatment stimulates the skin's natural collagen and elastin production, followed by a professional chemical exfoliation to improve texture, soften scarring, and restore radiance.",
          },
          {
            name: "Microdermabrasion",
            price: 150,
            desc: "A non-invasive resurfacing treatment that gently exfoliates the outermost layer of skin, softening fine lines, refining texture, and stimulating fresh, healthy cell renewal.",
          },
          {
            name: "Micropeel (Microdermabrasion & Chemical Exfoliation)",
            price: 150,
            desc: "A powerful duo combining microdermabrasion with a professional chemical exfoliation to dramatically smooth texture, brighten tone, and refresh the complexion in a single session.",
          },
          {
            name: "Mild Chemical Exfoliation",
            price: 130,
            desc: "A gentle, professional-grade exfoliation that dissolves dull surface cells to reveal smoother, brighter, more even-toned skin with minimal downtime.",
          },
        ],
      },
      {
        title: "Skin Technology Treatments",
        subtitle: "Modern, results-focused technologies for smoother, brighter, firmer-looking skin. Book on their own or add to any facial.",
        icon: "Zap",
        items: [
          {
            name: "Dermaplaning",
            price: 50,
            desc: "A precision exfoliation that gently sweeps away dull surface buildup and fine vellus hair (peach fuzz). Skin is left instantly smoother and brighter, makeup applies flawlessly, and serums absorb more effectively.",
          },
          {
            name: "HydraFacial (Hydradermabrasion)",
            price: 50,
            desc: "A multi-step treatment that cleanses, gently exfoliates, and extracts impurities while infusing the skin with hydrating, nourishing serums. Leaves the complexion visibly refreshed with a dewy, polished glow and no downtime.",
          },
          {
            name: "LED Light Therapy",
            price: 50,
            desc: "Targeted wavelengths of light help calm the look of redness, support collagen, and encourage a clearer, more even-looking complexion. A relaxing, non-invasive treatment with zero downtime, ideal as a finishing step to any facial.",
          },
          {
            name: "Microcurrent Facial",
            price: 50,
            desc: "Low-level electrical currents gently stimulate the facial muscles to visibly lift, tone, and sculpt. Supports a firmer-looking appearance, refined contours, and a naturally rested, radiant look.",
          },
        ],
      },
      {
        title: "Express & Targeted Care",
        subtitle: "Focused treatments and personal guidance for head-to-toe care.",
        icon: "Leaf",
        items: [
          {
            name: "Consultation",
            price: 15,
            desc: "A one-on-one skin analysis and personalized treatment-planning session, so every visit is built around your unique skin and goals.",
          },
          {
            name: "Lip Treatment",
            price: 15,
            desc: "An exfoliating, deeply hydrating treatment that smooths and softens the delicate lip area for a healthy, nourished finish.",
          },
        ],
      },
    ],
    additional: {
      title: "Additional Services",
      subtitle: "More ways we care for your skin, available alongside any treatment. Just ask us during your visit.",
      items: [
        {
          name: "Eyebrow Shaping",
          icon: "Eye",
          desc: "Expert shaping that frames your face and enhances your natural features.",
        },
        {
          name: "Tinting",
          icon: "Palette",
          desc: "Brow and lash tinting for defined, effortless everyday beauty.",
        },
        {
          name: "Facial Massage",
          icon: "Hand",
          desc: "Relaxing, sculpting massage techniques that boost circulation and leave the skin lifted and refreshed.",
        },
        {
          name: "Lactic Acid Exfoliation",
          icon: "FlaskConical",
          desc: "A gentle, hydrating exfoliation that brightens and smooths, ideal for dry or sensitive skin.",
        },
        {
          name: "Pigmentation Treatments",
          icon: "CircleDot",
          desc: "Targeted care for dark spots, sun damage, and uneven tone to reveal a brighter complexion.",
        },
        {
          name: "Rosacea Facial",
          icon: "HeartPulse",
          desc: "A calming treatment designed to reduce redness and soothe rosacea-prone skin.",
        },
        {
          name: "Acne Scar Treatment",
          icon: "ShieldCheck",
          desc: "Focused resurfacing care that softens the look of acne scarring and refines skin texture.",
        },
      ],
    },
  },
  faqs: [
    {
      q: "How do I book an appointment?",
      a: "Booking is easy and secure through our online Square booking page. Simply choose your treatment, pick a time that works for you, and confirm. We are by appointment only, so booking ahead guarantees your spot. You can also call us at (773) 600-1231 with any questions.",
    },
    {
      q: "I'm not sure which treatment is right for me. Where should I start?",
      a: "Start with a Consultation (from $15). We'll analyze your skin one-on-one, discuss your goals and concerns, and build a personalized treatment plan. If you book a facial directly, we always assess your skin first and tailor the treatment to what it needs that day.",
    },
    {
      q: "How should I prepare for my facial?",
      a: "Arrive with clean skin or minimal makeup if you can (we'll cleanse thoroughly either way). Avoid retinoids, strong exfoliants, and tanning for 48 to 72 hours before your visit, and stay well hydrated. If you're coming in for an advanced treatment, we'll share any extra prep steps when you book.",
    },
    {
      q: "What should I expect during my first visit?",
      a: "Your visit begins with a short skin analysis and conversation about your goals. Every treatment is then customized to your skin: deep cleansing, exfoliation, extractions where needed, massage, and a finishing routine matched to your skin type. You'll leave with personalized guidance for caring for your skin at home.",
    },
    {
      q: "Is there any downtime after a treatment?",
      a: "Most facials have no downtime. You may see mild, healthy redness for a few hours. Advanced treatments such as Derma Pen treatments and chemical exfoliation can involve 24 to 72 hours of redness and light flaking as your skin renews. We'll always explain exactly what to expect before your treatment begins.",
    },
    {
      q: "What aftercare should I follow?",
      a: "Keep your skin hydrated, wear SPF daily, and skip makeup for the rest of the day if possible. After advanced treatments, avoid direct sun, heavy sweating, and exfoliating products for a few days, and let any flaking shed naturally. We provide simple, personalized aftercare instructions at every visit.",
    },
    {
      q: "How often should I get a facial?",
      a: "For most skin types, every 4 to 6 weeks matches your skin's natural renewal cycle and keeps results consistent. If you're targeting a specific concern like acne, texture, or dark spots, we may recommend a short series of treatments spaced closer together, then a maintenance routine.",
    },
    {
      q: "Do you work with sensitive or acne-prone skin?",
      a: "Absolutely. Our Sensitive Facial is designed to calm and soothe reactive skin, and our Deep Cleaning / Acne Facial is ideal for congested, breakout-prone skin. We use gentle, organic and natural products, and every treatment is adjusted to your skin's tolerance.",
    },
    {
      q: "What is your cancellation policy?",
      a: "Please reschedule or cancel at least two days before your appointment. Late cancellations may incur a fee, and no-shows may be charged 50% of the reserved service. Life happens, so if something comes up, just reach out as early as you can and we'll do our best to accommodate you.",
    },
    {
      q: "Where are you located, and is parking available?",
      a: "We're at 8307 W Golf Rd, Suite #144 in Niles, IL, with free private lot parking right outside. The studio is wheelchair accessible, and we're open Tuesday through Sunday by appointment.",
    },
  ],
  gallery: [
    {
      src: "/images/gallery-3.png",
      alt: "Before and after skin tone and texture renewal treatment at Bahra Skincare",
      title: "Skin Tone & Texture Renewal",
    },
    {
      src: "/images/gallery-4.png",
      alt: "Before and after one treatment of Derma Pen treatment with chemical exfoliation",
      title: "Derma Pen + Chemical Exfoliation",
    },
    {
      src: "/images/gallery-1.png",
      alt: "Before and after acne clearing skin transformation",
      title: "Acne Clearing Journey",
    },
    {
      src: "/images/gallery-2.png",
      alt: "Client results showing a radiant, healthy glow after treatment",
      title: "A Radiant, Healthy Glow",
    },
    {
      src: "/images/gallery-5.jpg",
      alt: "Before and after facial treatment at Bahra Skincare showing smoother texture and a radiant glow",
      title: "Texture Smoothing & Radiant Glow",
    },
    {
      src: "/images/gallery-6.jpg",
      alt: "Before and after showing visible skin renewal during a chemical exfoliation journey",
      title: "Skin Renewal Journey",
    },
    {
      src: "/images/gallery-7.jpg",
      alt: "Before and after acne treatment results for a male client at Bahra Skincare",
      title: "Men's Acne Treatment",
    },
  ],
};
